export const enum ProductType {
  simple = 'simple',
  selection = 'selection',
}

export const enum ProductParentType {
  card = 'card',
  detail = 'detail',
}

export type ProductTagSize = 'sm' | 'md'
